import { TNote } from '@ws/shared/types';

import { ContentWindow } from './ContentWindow';
import styles from './ContentWindow.module.css';
import { DraggableWrapper } from './DraggableWrapper';
import { getCoordsAfterResize } from './getCoordsAfterResize';
import {
  TWindowCoords,
  TWindowGeometryPatch,
  TWindowMoveDelta,
  TWindowResizeDirection,
  TWindowSize,
} from './types';

interface DraggableWindowProps {
  note: TNote;
  size: TWindowSize;
  coords: TWindowCoords;
  scrollPercent: number;
  onGeometryChange(patch: TWindowGeometryPatch): void;
  onCollapseClick(): void;
  onCloseClick(): void;
}

// Окно полностью управляемо из стора: локального состояния геометрии больше нет,
// каждый завершённый жест сразу уезжает в redux через onGeometryChange.
export function DraggableWindow({
  note,
  size,
  coords,
  scrollPercent,
  onGeometryChange,
  onCollapseClick,
  onCloseClick,
}: DraggableWindowProps) {
  function handleDragStop(nextCoords: TWindowCoords) {
    onGeometryChange({ coords: nextCoords });
  }

  // Ресайз за левый или верхний край двигает окно, поэтому коммитим размер И
  // координаты одним патчем: иначе управляемый position вернёт окно на прежнее место
  // сразу после жеста. Дельта у react-rnd кумулятивная за жест.
  function handleResizeStop(delta: TWindowMoveDelta, direction: TWindowResizeDirection) {
    onGeometryChange({
      size: {
        width: size.width + delta.width,
        height: size.height + delta.height,
      },
      coords: getCoordsAfterResize(coords, delta, direction),
    });
  }

  function handleScrollStop(newPercent: number) {
    onGeometryChange({ scrollPercent: newPercent });
  }

  return (
    <DraggableWrapper
      style={{ position: 'fixed' }}
      className={styles['window-wrapper']}
      handlerClassName={styles['window__header']}
      size={size}
      coords={coords}
      onDragStop={handleDragStop}
      onResizeStop={handleResizeStop}
    >
      <ContentWindow
        note={note}
        scrollPercent={scrollPercent}
        onScrollStop={handleScrollStop}
        onCollapseClick={onCollapseClick}
        onCloseClick={onCloseClick}
      />
    </DraggableWrapper>
  );
}
